import React from 'react';
import styles from './Spacer.module.less';

export default function Spacer() {
  return (
    <div className={styles.divider}>
      <span>OR</span>
    </div>
  );
}
